import { ProposalField, ProposalFieldJSON } from "work/entities/proposal/proposal";

export interface TopicContextJSON {
  audience: Audience;
  field: ProposalFieldJSON;
}

export enum Audience {
  VendorReviewers = "vendorReviewers",
  ClientReviewers = "clientReviewers",
  AllReviewers = "allReviewers"
}
export class TopicContext {
  public readonly audience: Audience;
  public readonly field: ProposalField;

  constructor(audience: Audience, field: ProposalField) {
    this.audience = audience;
    this.field = field;
  }

  public isEqualTo(other: TopicContext): boolean {
    return this.audience === other.audience && this.field.isEqualTo(other.field);
  }

  public toJSON(): TopicContextJSON {
    return {
      audience: this.audience,
      field: this.field?.toJSON()
    };
  }

  public static fromJSON(json: TopicContextJSON): TopicContext | undefined {
    const field = ProposalField.fromJSON(json.field);
    if (!field) return undefined;
    return new TopicContext(json.audience, field);
  }
}
